import { render } from "./FitnessTrackerPro.vue?vue&type=template&id=56b034ac&scoped=true"
import script from "./FitnessTrackerPro.vue?vue&type=script&lang=js"
export * from "./FitnessTrackerPro.vue?vue&type=script&lang=js"

import "./FitnessTrackerPro.vue?vue&type=style&index=0&id=56b034ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b034ac"]])

export default __exports__